@if (data && data.id) {
  <div (click)="changeCompletionStatus()">
    @if (data.status !== taskStatusEnum.finished) {
      <mat-icon class="open">check_circle</mat-icon>
    } @else {
      <mat-icon class="close">unpublished</mat-icon>
    }
  </div>
}
